import React, { useState } from "react";
import Subheading from "../Common/Subheading";
import CustomersIcon from "../../assets/icons/customers.svg2";
import ManageUsers from "./ManageUsers";
import ManageUsersRoles from "./ManageUsersRoles";
import HelpButton from "../HelpContent/HelpButton";
import { isUserPermitted } from "../helpers/pageProps";

function UsersSettings() {
  const [userCollapsed, setUserCollapsed] = useState(false);
  const [roleCollapsed, setRoleCollapsed] = useState(true);
  return (
    <div className="mb-5">
      <Subheading
        Icon={CustomersIcon}
        heading="Users Settings"
        subheading="User settings and user system controls ."
      />
      {isUserPermitted("view_user") && (
        <div className="my-3">
          <ManageUsers
            collapsed={userCollapsed}
            setCollapsed={() => {
              setUserCollapsed(!userCollapsed);
              if (userCollapsed) {
                setRoleCollapsed(true);
              }
            }}
          />
        </div>
      )}
      {isUserPermitted("view_permissions") && (
        <div className="my-3">
          <ManageUsersRoles
            collapsed={roleCollapsed}
            setCollapsed={() => {
              setRoleCollapsed(!roleCollapsed);
              if (roleCollapsed) {
                setUserCollapsed(true);
              }
            }}
          />
        </div>
      )}
    </div>
  );
}

export default UsersSettings;
